import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Price from './Price';
import cartAnalytics from '../Selection/cartAnalytics';
import Button from '../Elements/Button/Button';
import Checkbox from '../Elements/Checkbox/Checkbox';
import Input from '../Elements/Input/Input';
import Radio from '../Elements/Radio/Radio';
import { addToBag, productAlert, changeAddressInput, booleanChange } from '../../actions/checkout';
import { origin } from '../../config';
import { addEvent, removeEvent, addClass, removeClass, scrollTo, purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { fieldValidation } from '../../utils/string';
import s from './Purchase.scss';

class Purchase extends Component {
	constructor(props) {
		super(props);

		const { sizes } = props;

		this.state = {
			formError: false,
			emailError: false,
			addedToBag: false,
			showNotifyThanks: false,
			firstSelected: false,
			secondSelected: false,
			initialScroll: false,
			firstSizeGroupOpen: true,
			secondSizeGroupOpen: false,
			showScrollTopButton: false,
			interest: ['women', 'men'],
			selected: sizes.length === 1 ? sizes[0].item : false,
		};

		this.formElement = React.createRef();
	}

	componentDidMount() {
		let showScrollTopButton = false;

		addEvent(document.querySelector('body'), 'click.clearFormError', (e) => {
			if (this.formElement.current && !this.formElement.current.contains(e.target) && this.state.formError) {
				e.stopPropagation();
				e.preventDefault();
				this.setState({
					formError: false,
				});
				this.props.toggleNotifyMe(false);
			}
		});

		addEvent(window, 'scroll.sizeSelector', () => {
			const top = window.pageYOffset || document.documentElement.scrollTop;
			const scrollTolerance = window.innerWidth < 600 ? 10 : window.innerHeight / 2;

			if (!showScrollTopButton && top > window.innerHeight) {
				showScrollTopButton = true;
				this.setState({ showScrollTopButton });
			} else if (showScrollTopButton && top < window.innerHeight) {
				showScrollTopButton = false;
				this.setState({ showScrollTopButton });
			}

			if (!this.props.showNotifyMe && this.state.initialScroll !== false && (this.state.initialScroll - scrollTolerance > top || this.state.initialScroll + scrollTolerance < top)) {
				this.props.toggleSelectingSize(false);
				this.setState({
					initialScroll: false,
					formError: false,
				});
			}
		});

		addEvent(window, 'keydown.clearFormError', (e) => {
			if (e.key === 'Escape') {
				this.props.toggleSelectingSize(false);
				this.setState({
					formError: false,
				});
				this.props.toggleNotifyMe(false);
			}
		});
	}

	componentWillUnmount() {
		removeEvent(document.querySelector('body'), 'click.clearFormError');
		removeEvent(window, 'keydown.clearFormError');
		removeClass(document.body, 'u_addedToBag');
		removeEvent(window, 'scroll.sizeSelector');
	}

	onNotifyMe = ($form, sizes) => {
		const { selected, interest } = this.state;
		const { selectingSize } = this.props;

		if (selected && selectingSize) {
			let hasErrors = false;
			const $input = $form.querySelector('#notifyMeEmail');
			const value = $input.value;
			const returnErrors = this.onAddressInputBlur('email', value);
			if (returnErrors) hasErrors = true;

			if (hasErrors) return;

			this.props.productAlert({
				selected,
				interest,
			}).then(() => {
				this.setState({ showNotifyThanks: true });

				window.setTimeout(() => {
					this.setState({
						addedToBag: false,
						selected: sizes.length === 1 ? sizes[0].item : false,
						firstSelected: false,
						secondSelected: false,
						showNotifyThanks: false,
					});
				}, 3000);

				return 1;
			}).catch(() => { console.log('DEBUG: failed to set up notification'); });
		}

		if (!selectingSize) {
			const top = window.pageYOffset || document.documentElement.scrollTop;
			this.props.toggleSelectingSize(true);
			this.setState({
				initialScroll: top,
			});
		}
	}

	addToBagHandler = (e) => {
		e.preventDefault();
		const { setup, sizes, productCache, productId, currentPath, product, selectingSize, showNotifyMe } = this.props;
		const currentCategory = currentPath.slice(0, currentPath.lastIndexOf('/'));
		let { selected } = this.state;

		// All sizes must be added for purchase to be successful.
		if (selected && selectingSize) {
			const cachedProduct = productCache[setup.market][setup.pricelist].products[productId];

			if (sizes.length === 1) selected = sizes[0].item;

			// Check for stock to purchase or notify me.
			if (showNotifyMe) {
				this.onNotifyMe(e.currentTarget, sizes);
			} else if (sizes.filter((item) => item.item === selected)?.[0]?.stock === 0) {
				this.props.toggleNotifyMe(true);
			} else {
				this.props.addToBag(selected, 1, currentPath, cachedProduct).then((response) => {
					addClass(document.body, 'u_addedToBag');

					cartAnalytics(cachedProduct, selected, setup, product, currentCategory, false, 1, response.data.selection);
					setTimeout(() => {
						removeClass(document.body, 'u_addedToBag');
						this.setState({
							addedToBag: false,
							selected: sizes.length === 1 ? sizes[0].item : false,
							firstSelected: false,
							secondSelected: false,
						});
						this.props.toggleSelectingSize(false);
					}, 3000);

					return response;
				}).catch((err) => { console.log('DEBUG: add to bag failed', err); });

				this.setState({
					addedToBag: true,
				});
			}

			return;
		}

		if (!selectingSize) {
			const top = window.pageYOffset || document.documentElement.scrollTop;
			this.props.toggleSelectingSize(true);
			this.setState({
				initialScroll: top,
			});
			return;
		}

		this.setState({
			formError: true,
		});
	}

	expandSizeGroupHandler = (e) => {
		const value = e.currentTarget.value;

		this.setState((prevState) => ({ [`${value}SizeGroupOpen`]: !prevState[`${value}SizeGroupOpen`] }));
	}

	selectSizeHandler = (id, item) => {
		const { sizes } = this.props;

		if (item.indexOf('-') === -1) {
			this.setState((prevState) => {
				const nextState = {
					...prevState,
					formError: false,
					[id]: item,
				};

				if (nextState.firstSelected && !nextState.secondSelected) {
					nextState.secondSizeGroupOpen = true;
				}

				if (nextState.firstSelected && nextState.secondSelected) {
					if (nextState.firstSelected && nextState.secondSelected) {
						const testSelectedRegex = new RegExp(`${nextState.firstSelected}\\s?\\/\\s?${nextState.secondSelected}`);
						const [selectedSizeItem] = sizes.filter((size) => testSelectedRegex.test(size.name));
						if (selectedSizeItem) {
							nextState.selected = selectedSizeItem.item;
						}
					}
				}
				return nextState;
			});
			this.props.toggleNotifyMe(false);
			return;
		}
		this.setState({
			formError: false,
			selected: item,
		});
		this.props.toggleNotifyMe(false);
	}

	onAddressInputChange = (id, value) => {
		this.props.changeAddressInput('address', 'email', value);
		this.setState({ emailError: false });
	}

	onAddressInputBlur = (id, value) => {
		this.onAddressInputChange('email', value);

		if (fieldValidation(value, 'email')) {
			this.setState({ emailError: translate(this.props.setup, `error${fieldValidation(value, 'email')}`) });
			return true;
		}

		return false;
	}

	onBooleanChange = (id) => {
		this.props.booleanChange(id);
	};

	scrollToPageTop = (e) => {
		e.preventDefault();
		scrollTo(500, 0);
	}

	newsletterInterestChangeHandler = (id) => {
		const selectedInterest = id.slice(0, id.indexOf('Newsletter'));
		const initialState = {
			interest: ['women', 'men'],
		};

		this.setState((prevState) => {
			let interest = prevState.interest.slice(0);
			if (interest.indexOf(selectedInterest) === -1) interest = [...interest, selectedInterest];
			else if (interest.length > 1) {
				interest = [...interest.slice(0, interest.indexOf(selectedInterest)), ...interest.slice(interest.indexOf(selectedInterest) + 1)];
			} else {
				interest = [...initialState.interest.slice(0, initialState.interest.indexOf(selectedInterest)), ...initialState.interest.slice(initialState.interest.indexOf(selectedInterest) + 1)];
			}

			return {
				...prevState,
				interest,
			};
		});
	};

	toggleSelectingSizeHandler = (e) => {
		e.preventDefault();
		this.props.toggleSelectingSize(false);
	};

	render() {
		const { setup, product, sizes, checkout, price, showNotifyMe, selectingSize, toggleInfoSection, comingSoon } = this.props;
		const { formError, emailError, addedToBag, showNotifyThanks, selected, firstSelected, secondSelected, showScrollTopButton, firstSizeGroupOpen, secondSizeGroupOpen, interest } = this.state;
		let soldOut = this.props.soldOut;

		const splitSizes = {};
		const splitSizesStockCombined = sizes.reduce((acc, item) => {
			if (item.name.indexOf('/') !== -1) {
				const [splitNameFirst, splitNameSecond] = item.name.split('/').map((n) => n.trim());

				if (!acc[splitNameFirst]) acc[splitNameFirst] = item.stock;
				else acc[splitNameFirst] += item.stock;

				if (!acc[splitNameSecond]) acc[splitNameSecond] = item.stock;
				else acc[splitNameSecond] += item.stock;
			}
			return acc;
		}, {});

		sizes.forEach((item) => {
			if (item.name.indexOf('/') !== -1) {
				const [splitNameFirst, splitNameSecond] = item.name.split('/').map((n) => n.trim());
				if (!splitSizes.first) {
					splitSizes.first = [];
					splitSizes.second = [];
				}

				// Only use sizes that the second is selected on OR sizes that aren't yet already added (unique).
				if ((secondSelected && secondSelected === splitNameSecond) || (!secondSelected && splitSizes.first.filter((i) => i.key === splitNameFirst).length === 0)) {
					let disabled = false;
					let info = '';
					if (secondSelected) {
						const testFirstRegex = new RegExp(`${splitNameFirst}\\s?\\/\\s?${secondSelected}`);
						if (testFirstRegex.test(item.name)) {
							if (item.stock === 0) {
								disabled = true;
								info = translate(setup, 'sizeNotifyMe');
							} else if (item.stock <= 3) info = translate(setup, 'sizeFewLeft');
						}
					} else if (!secondSelected) {
						if (splitSizesStockCombined[splitNameFirst] === 0) {
							disabled = true;
							info = translate(setup, 'sizeNotifyMe');
						} else if (splitSizesStockCombined[splitNameFirst] <= 3) info = translate(setup, 'sizeFewLeft');
					}
					splitSizes.first.push({
						key: splitNameFirst,
						value: splitNameFirst,
						selected: firstSelected === splitNameFirst,
						disabled,
						info,
					});
				}

				if ((firstSelected && firstSelected === splitNameFirst) || (!firstSelected && splitSizes.second.filter((i) => i.key === splitNameSecond).length === 0)) {
					let disabled = false;
					let info = '';
					if (firstSelected) {
						const testSecondRegex = new RegExp(`${firstSelected}\\s?\\/\\s?${splitNameSecond}`);
						if (testSecondRegex.test(item.name)) {
							if (item.stock === 0) {
								disabled = true;
								info = translate(setup, 'sizeNotifyMe');
							} else if (item.stock <= 3) info = translate(setup, 'sizeFewLeft');
						}
					} else if (!firstSelected) {
						if (splitSizesStockCombined[splitNameSecond] === 0) {
							disabled = true;
							info = translate(setup, 'sizeNotifyMe');
						} else if (splitSizesStockCombined[splitNameSecond] <= 3) info = translate(setup, 'sizeFewLeft');
					}
					splitSizes.second.push({
						key: splitNameSecond,
						value: splitNameSecond,
						selected: secondSelected === splitNameSecond,
						disabled,
						info,
					});
				}
			} else {
				if (!splitSizes.general) splitSizes.general = [];
				let disabled = false;
				let info = '';
				if (item.stock === 0) {
					disabled = true;
					info = translate(setup, 'sizeNotifyMe');
				} else if (item.stock <= 3) info = translate(setup, 'sizeFewLeft');
				splitSizes.general.push({
					key: item.item,
					value: item.name,
					selected: selected === item.item,
					disabled,
					info,
				});
			}
		});

		let buttonText = !selected ? translate(setup, 'chooseSize') : translate(setup, 'addToBag');
		if (addedToBag) buttonText = translate(setup, 'addedToBag');
		if (sizes.filter((item) => item.item === selected)?.[0]?.stock === 0) {
			soldOut = true;
			buttonText = translate(setup, 'sizeNotifyMeContinue');
		}
		if (!selectingSize) buttonText = translate(setup, 'chooseSize');
		if (selectingSize && firstSelected && !secondSelected) buttonText = translate(setup, 'chooseSizeLength');
		if (selectingSize && secondSelected && !firstSelected) buttonText = translate(setup, 'chooseSizeWaist');

		return (
			<form className={s.purchase} onSubmit={this.addToBagHandler} ref={this.formElement}>
				{
					showScrollTopButton && (
						<a className={s.purchase_scrollTop} onClick={this.scrollToPageTop} href="#top">
							<svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fillRule="evenodd" clipRule="evenodd" fill="black" d="M0.462853 3.82843L3.64483 0.646445C3.8401 0.451183 4.15668 0.451183 4.35194 0.646445L7.53392 3.82843C7.72918 4.02369 7.72918 4.34027 7.53392 4.53553C7.33866 4.73079 7.02208 4.73079 6.82681 4.53553L4.49839 2.20711L4.49839 16H3.49839L3.49839 2.20711L1.16996 4.53553C0.974698 4.73079 0.658115 4.73079 0.462853 4.53553C0.267591 4.34027 0.267591 4.02369 0.462853 3.82843Z" />
							</svg>
						</a>
					)
				}
				<div className={s.purchase_info}>
					<h1 className={s.purchase_info_title}>
						<span className={s.purchase_info_title_name}>{ product.name }</span>
						<span className={s.purchase_info_title_variant}>{ product.variantName }</span>
						{
							!selectingSize && selected && (
								<span className={s.purchase_info_title_variant_selectedSize}>
									{ splitSizes.general ? splitSizes.general.filter((item) => item.key === selected)?.[0]?.value : `${translate(setup, 'firstSizeGroupShort')} ${firstSelected} / ${translate(setup, 'secondSizeGroupShort')} ${secondSelected}` }
								</span>
							)
						}
					</h1>
					<div className={s.purchase_info_price}>
						<Price price={price} soldOut={soldOut} comingSoon={comingSoon} product />
						{ product.variant_coming_soon_bool && <span className={s.purchase_info_price_comingSoon}>{ translate(setup, 'comingSoon') }</span> }
					</div>
				</div>
				{
					selectingSize && (
						<div className={s.purchase_sizes}>
							{
								splitSizes.general && Object.keys(splitSizes.general).length > 0 && (
									<div className={[s.purchase_sizes_choice, s.purchase_sizes_choice__selected].join(' ')}>
										<div className={s.purchase_sizes_choice_options}>
											<Radio variantClasses={['radio__size']} id="sizes" options={splitSizes.general} selected={selected} inputChange={this.selectSizeHandler} isError={formError} />
										</div>
									</div>
								)
							}
							{
								splitSizes.first && (
									<div className={[s.purchase_sizes_choice, (firstSizeGroupOpen ? s.purchase_sizes_choice__selected : null)].join(' ')}>
										<button className={s.purchase_sizes_choice_select} type="button" onClick={this.expandSizeGroupHandler} value="first">
											<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M6 1L11 6" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
												<path d="M1 6L6 1" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
											</svg>
											<span>{ firstSelected ? `${translate(setup, 'firstSizeGroupShort')} ${firstSelected}` : translate(setup, 'firstSizeGroup') }</span>
										</button>
										<div className={s.purchase_sizes_choice_options}>
											<Radio variantClasses={['radio__size']} id="firstSelected" options={splitSizes.first} selected={firstSelected} inputChange={this.selectSizeHandler} isError={formError} />
										</div>
									</div>
								)
							}
							{
								splitSizes.second && firstSelected && (
									<div className={[s.purchase_sizes_choice, (secondSizeGroupOpen ? s.purchase_sizes_choice__selected : null)].join(' ')}>
										<button className={s.purchase_sizes_choice_select} type="button" onClick={this.expandSizeGroupHandler} value="second">
											<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M6 1L11 6" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
												<path d="M1 6L6 1" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
											</svg>
											<span>{ secondSelected ? `${translate(setup, 'secondSizeGroupShort')} ${secondSelected}` : translate(setup, 'secondSizeGroup') }</span>
										</button>
										<div className={s.purchase_sizes_choice_options}>
											<Radio variantClasses={['radio__size']} id="secondSelected" options={splitSizes.second} selected={secondSelected} inputChange={this.selectSizeHandler} isError={formError} />
										</div>
									</div>
								)
							}
							<button className={s.purchase_sizes_guide} value="size-guide" type="button" onClick={toggleInfoSection}>
								<span>{ translate(setup, 'productSizeGuide') }</span>
							</button>
						</div>
					)
				}
				{
					showNotifyMe && selected && selectingSize ? (
						<div className={s.purchase_notifyMe}>
							<Input variantClasses={['input__notifyMe', 'label__notifyMe']} id="notifyMeEmail" type="email" isError={emailError} value={checkout.payment.address.email} inputChange={this.onAddressInputChange} placeholder={translate(setup, 'labelEmail')} label={translate(setup, 'labelNotifyMe')} inputBlur={this.onAddressInputBlur} />
							<Checkbox id="subscribeToNewsletter" selected={checkout.payment.address.newsletter} inputChange={this.onBooleanChange}>
								<span dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'newsletterTerms')) }} />
							</Checkbox>
							{
								checkout.payment.address.newsletter && (
									<div className={s.purchase_notifyMe_interest}>
										<Checkbox id="womenNewsletter" label={translate(setup, 'newsletterWomen')} selected={interest.indexOf('women') !== -1} inputChange={this.newsletterInterestChangeHandler} />
										<Checkbox id="menNewsletter" label={translate(setup, 'newsletterMen')} selected={interest.indexOf('men') !== -1} inputChange={this.newsletterInterestChangeHandler} />
									</div>
								)
							}
							<Button variantClasses={(emailError ? null : ['button__inverse'])} type="submit">{ !showNotifyThanks ? translate(setup, 'notifyMeSubmit') : translate(setup, 'notifyMeThanks') }</Button>
						</div>
					) : (
						<div className={s.purchase_submit}>
							<Button variantClasses={(selected && selectingSize ? ['button__inverse'] : null)} mouseEnterEventHandler={this.addToBagMouseEnterHandler} mouseLeaveEventHandler={this.addToBagMouseLeaveHandler}>{ buttonText }</Button>
						</div>
					)
				}
				{ selectingSize && <Button variantClasses={['button__invisible', 'button__desktopHide']} clickEventHandler={this.toggleSelectingSizeHandler}><span>{ translate(setup, 'close') }</span></Button> }
				{ checkout.addToBagError ? <div className={s.purchase_error}>{ translate(setup, 'addToBagError') }</div> : null }
			</form>
		);
	}
}

const mapState = ({ checkout, productCache }, { setup, currentPath, sizes, productId }) => ({
	sizes,
	productId,
	currentPath,
	setup,
	checkout,
	productCache,
});

export default hot(module)(connect(mapState, { addToBag, productAlert, changeAddressInput, booleanChange })(Purchase));
